import { Dispatch, RefObject, SetStateAction, useEffect, useMemo } from 'react';

import { Box } from '@mui/material';
import { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid-pro';

import { PanelGrid } from 'components/grid';
import { RequestOptionsType } from 'hooks/useRequestListagem';
import { useQueryLojasModal } from 'pages/compra/configuracao-pedido/hooks';
import { LojasProps } from 'pages/compra/configuracao-pedido/types';

interface ConfigPedidoLojasModalGrid {
    open: boolean;
    valueFilter: string;
    requestOptionsLojas?: RequestOptionsType;
    lojaMapRef: RefObject<Map<number, LojasProps>>;
    selectedLojas: LojasProps[];
    setSelectedLojas: Dispatch<SetStateAction<LojasProps[]>>;
}

const columns: GridColDef[] = [
    { field: 'cdLoja', headerName: 'Codigo', minWidth: 80 },
    { field: 'dsNomeFantasia', headerName: 'Nome Fantasia', flex: 1, minWidth: 150 },
    { field: 'dsRazaoSocial', headerName: 'Razao Social', flex: 1, minWidth: 150 },
];

export function ConfigPedidoLojasModalGrid({
    open,
    requestOptionsLojas,
    valueFilter,
    lojaMapRef,
    selectedLojas,
    setSelectedLojas,
}: ConfigPedidoLojasModalGrid) {
    const { data, isFetching, refetch } = useQueryLojasModal({ open, requestOptionsLojas, valueFilter });

    useEffect(() => {
        if (data?.data) {
            data.data.forEach((loja) => lojaMapRef.current.set(loja.idLoja, loja));
        }
    }, [data]);

    const rows = useMemo(() => {
        if (!data?.data) return [];

        return data.data.map((loja) => ({
            id: loja.idLoja,
            cdLoja: loja.cdLoja,
            dsNomeFantasia: loja.dsNomeFantasia,
            dsRazaoSocial: loja.dsRazaoSocial,
        }));
    }, [data]);

    const onClickRow = (selectionModel: GridRowSelectionModel) => {
        data?.data?.forEach((loja) => lojaMapRef.current.set(loja.idLoja, loja));

        const lojas = Array.from(selectionModel.ids)
            .map((id) => lojaMapRef.current.get(id as number))
            .filter(Boolean) as LojasProps[];

        setSelectedLojas(lojas);
    };

    return (
        <Box sx={{ height: 400 }} onClick={(e) => e.stopPropagation()}>
            <PanelGrid
                checkboxSelection
                autoHeight={false}
                rows={rows}
                rowsCount={data?.total ?? 0}
                columns={columns}
                reload={refetch}
                loading={isFetching}
                onClickRow={onClickRow}
                keepNonExistentRowsSelected
                selectionModel={{
                    type: 'include',
                    ids: new Set(selectedLojas.map((loja) => loja.idLoja)),
                }}
            />
        </Box>
    );
}
